import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { UserService } from '../../../../api/services/user.service'

@Injectable({
  providedIn: 'root',
})
export class UserResolverService {
  constructor(private userService: UserService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    const practiceId = route.paramMap.get('practice_id')
    const userid = route.paramMap.get('userid')

    if (userid == '-') {
      return of(null)
    } else {
      // call api and return data
      return this.userService.userGet({ id: +userid, practiceId: practiceId })
    }
    // here calling api
  }
}
